export default typeof process !== 'undefined' && process?.title !== 'browser'
